(function() {
	'use strict';

	angular.module('dutySheet').config(config);

	function config($stateProvider) {
		$stateProvider.state('dutySheet', {
			url : '/duty-sheet',
			views : {
				'dutySheetView' : {
					templateUrl : 'duty-sheet/views/duty-sheet.tpl.html',
					controller : 'DutySheetCtrl',
					controllerAs : 'dutySheet'
				}
			}
		});
	}
}());
